import { RealtimeClient } from "./RealtimeClient";
import { RestClient } from "./restClient";

export class SystemNotificationService {
	constructor(options) {
		this._options = options;
		this._rc = new RealtimeClient();
		this._restClient = new RestClient();
	}

	subscribeByUser(userId, callback) {
		const args = {
			type: "user",
			userId
		};
		return this._rc.subscribe("ecosystem", "/systemNotifications", args, function (msg) {
			const response = JSON.parse(msg);
			if (response) {
				if (callback) {
					callback(null, response);
				}
			}
		});
	}

	acknowledgeSystemNotification(notificationId, callback) {
		const url = `/ecosystem/api/systemNotifications/${notificationId}/acknowledge`;
		this._restClient.exec_get(url, callback);
	}
}
